
import { Box, Stack, Typography } from '@mui/material';
import * as React from 'react';
import { getImgPath } from '../../store/JSTool';
import { useSelector, useDispatch } from 'react-redux';
import { settingActions, settingObj } from '../../store/SettingSlice';

export default function AboutSectionView(props) {

    const settingData = useSelector(state => state.settingData);

    return (
        <Stack sx={{
            bgcolor: 'white',
            alignItems: 'center',
            pb: settingData.isMobile && 2,
            width: 1,
        }}>

            <ColorTextView id='worldwide_id' whiteStr='WORLDWIDE' colorStr='PLAY' />
            <ColorTextView id='boundless_id' whiteStr='BOUNDLESS' colorStr='JOY' />

            <Box
                id='imagining_id'
                component={'div'}
                sx={{
                    opacity: 0,
                    color: 'black',
                    fontFamily: settingData.fontFM,
                    fontSize: settingData.isMobile ? 17 : 32,
                    textAlign: 'center',
                    width: settingData.isMobile ? 0.98 : '1200px',
                    mt: settingData.isMobile ? 2 : 3,
                    mb: settingData.isMobile ? 1 : 3,
                    lineHeight: settingData.isMobile ? '30px' : '40px',
                }}
                dangerouslySetInnerHTML={{
                    __html:
                        `
                        ${settingData.langDic['lang11']}
                        `
                }} />

            <Stack
                id={'three_boxs_id'}
                sx={{
                    width: 1,
                    opacity: 0,
                    flexDirection: 'row',
                    justifyContent: 'center',
                    mt: 2,
                    mb: settingData.isMobile ? 0 : 5,
                }}>
                <ColorBox title={settingData.langDic['lang12']} color='#FF5F47' />

                <ColorBox title={settingData.langDic['lang13']} color='#FFA127' />

                <ColorBox title={settingData.langDic['lang15']} color='#FFC714' />
            </Stack>

        </Stack>
    )
}

function ColorTextView(props) {
    const settingData = useSelector(state => state.settingData);

    return (
        <Stack
            id={props.id}
            sx={{
                opacity: 0,
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
            }}>
            <Typography sx={{
                color: 'black',
                fontFamily: 'Lexend Deca',
                fontSize: settingData.isMobile ? 22 : 55,
                height: settingData.isMobile ? '30px' : '70px',
                lineHeight: settingData.isMobile ? '30px' : '70px',

            }}>
                {props.whiteStr}
            </Typography>

            <Typography sx={{
                color: '#FFA129',
                fontFamily: 'Lexend Deca',
                fontSize: settingData.isMobile ? 22 : 55,
                ml: 2,
                height: settingData.isMobile ? '30px' : '70px',
                lineHeight: settingData.isMobile ? '30px' : '70px',
            }}>
                {props.colorStr}
            </Typography>
        </Stack>
    );
}

function ColorBox(props) {
    const settingData = useSelector(state => state.settingData);

    return (
        <Stack sx={{
            justifyContent: 'center',
            alignItems: 'center',
            bgcolor: props.color,
            width: settingData.isMobile ? 0.3 : '265px',
            height: settingData.isMobile ? '130px' : '265px',
            borderRadius: '10px',
            mx: settingData.isMobile ? 0.5 : 3,
        }}>

            <Box
                component={'div'}
                sx={{
                    color: 'white',
                    fontFamily: settingData.fontFM,
                    fontSize: settingData.isMobile ? (settingData.lang == 'en' ? 10 : 13) : (settingData.lang == 'en' ? 19 : 20),
                    textAlign: 'center',
                    lineHeight: settingData.isMobile ? '20px' : '35px',
                }}
                dangerouslySetInnerHTML={{
                    __html:
                        `
                        ${props.title}
                        `
                }} />

        </Stack>

    );
}

